import React, { useState } from "react";
import { Title, Flex, Stack, Button } from "@mantine/core";
import colorsCustom from "../designTokens/colorsCustom";
import { useTranslation } from "react-i18next";

const CollectionContentOfTable = ({
	collection,
	selectedThread,
	setSelectedThread,
	isMobile,
	isVisible = false,
	setIsVisible,
}) => {
	const { t } = useTranslation();

	return (
		<Stack
			gap={8}
			w={isMobile ? "100%" : "40%"}
			h={isMobile ? "100vh" : "auto"}
			p={isMobile ? 24 : 0}
			style={{
				position: isMobile ? "fixed" : "static",
				overflow: "scroll",
				top: 0,
				left: isVisible ? 0 : "-100%",
				transition: "all 0.3s ease-in-out",
				zIndex: 8,
				backgroundColor: isMobile ? "white" : "transparent",
			}}
		>
			<Stack gap={8}>
				<Title order={3} fw={400} c={colorsCustom.ui.dark.bold}>
					{t("myCollection.tableOfContents")}
				</Title>
				<Stack gap={0}>
					{collection.threadList.map((thread, index) => (
						<Flex
							key={index}
							p={"16px 0"}
							style={{
								borderBottom: `1px solid ${colorsCustom.ui.dark.subtle}`,
								cursor: "pointer",
							}}
							onClick={() => {
								setSelectedThread(thread);
								setIsVisible(false);
							}}
						>
							<Title
								order={5}
								fw={selectedThread === thread ? 800 : 600}
								c={colorsCustom.ui.dark.bold}
								style={{
									display: "block",
									WebkitLineClamp: 1,
									WebkitBoxOrient: "vertical",
									overflow: "hidden",
									lineHeight: "1.5rem",
									maxHeight: "1.5rem",
									whiteSpace: "pre-wrap",
								}}
							>
								{index + 1} - {thread.text.split(/(?<=[.!?\]])(?=\s|\n|$)/)[0].replace(/�/g, "")}
							</Title>
						</Flex>
					))}
				</Stack>
			</Stack>
		</Stack>
	);
};

export default CollectionContentOfTable;
